import template from './oo-admin-header-navbar.html';

export default {
	template,
	controllerAs: '$ctrl',
	require: {
		parent: '^^ooAdmin',
	},
};
